// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__176kH","legacyBtn":"MutateMid_legacyBtn__2NnR-"};